import React from 'react';
import Navbar from '../components/Navbar';

const AboutPage: React.FC = () => {
  return (
    <div className="bg-gray-50 min-h-screen">
      <Navbar />
      
      {/* Hero Section */}
      <div className="relative bg-cover bg-center h-72" style={{ 
        backgroundImage: 'url(https://images.unsplash.com/photo-1580237072825-f9308893c2c9?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80)' 
      }}>
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        <div className="container-custom mx-auto h-full flex flex-col items-center justify-center relative z-10 px-4">
          <h1 className="text-4xl md:text-5xl font-bold text-white text-center">
            About Us
          </h1>
        </div>
      </div>
      
      {/* Main Content */}
      <div className="container-custom mx-auto py-12 px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-gray-800 mb-6">Our Story</h2>
          
          <p className="text-lg text-gray-600 mb-6">
            Founded in 2015, Costa Rica Properties has been dedicated to helping clients find their dream properties in one of the world's most beautiful countries. Whether you're looking for a vacation home, a permanent residence, or an investment opportunity, our team of experts is here to guide you through every step of the process.
          </p>
          
          <p className="text-lg text-gray-600 mb-10">
            With our deep knowledge of the Costa Rican real estate market and our commitment to personalized service, we have successfully matched hundreds of clients with properties that perfectly suit their needs and preferences.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-12">
            <div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">Our Mission</h3>
              <p className="text-gray-600">
                Our mission is to provide exceptional service and expert guidance to clients looking to invest in Costa Rican real estate. We strive to make the property buying process as smooth and enjoyable as possible, while ensuring that our clients make informed decisions that align with their goals.
              </p>
            </div>
            <div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">Our Vision</h3>
              <p className="text-gray-600">
                We aim to be the most trusted and respected real estate agency in Costa Rica, known for our integrity, expertise, and commitment to client satisfaction. We envision a future where owning property in Costa Rica is accessible to anyone who dreams of living in this tropical paradise.
              </p>
            </div>
          </div>
          
          <h2 className="text-3xl font-bold text-gray-800 mb-6">Meet Our Team</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            {/* Team Member */}
            <div className="bg-white p-6 rounded-lg shadow-md">
              <img 
                src="https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80" 
                alt="Roger Salas" 
                className="w-32 h-32 rounded-full mx-auto mb-4 object-cover"
              />
              <h3 className="text-xl font-semibold text-center text-gray-800">Roger Salas</h3>
              <p className="text-primary text-center mb-4">Founder & CEO</p>
              <p className="text-gray-600 text-center">
                With over 15 years of experience in Costa Rican real estate, Roger founded Costa Rica Properties with a vision of providing exceptional service to international clients.
              </p>
            </div>
            
            {/* Team Member */}
            <div className="bg-white p-6 rounded-lg shadow-md">
              <img 
                src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80" 
                alt="Maria Rodriguez" 
                className="w-32 h-32 rounded-full mx-auto mb-4 object-cover"
              />
              <h3 className="text-xl font-semibold text-center text-gray-800">Maria Rodriguez</h3>
              <p className="text-primary text-center mb-4">Lead Real Estate Agent</p>
              <p className="text-gray-600 text-center">
                Born and raised in Costa Rica, Maria has unparalleled knowledge of the local market and specializes in luxury properties along the Pacific coast.
              </p>
            </div>
            
            {/* Team Member */}
            <div className="bg-white p-6 rounded-lg shadow-md">
              <img 
                src="https://images.unsplash.com/photo-1542909168-82c3e7fdca5c?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80" 
                alt="David Smith" 
                className="w-32 h-32 rounded-full mx-auto mb-4 object-cover"
              />
              <h3 className="text-xl font-semibold text-center text-gray-800">David Smith</h3>
              <p className="text-primary text-center mb-4">Legal Expert</p>
              <p className="text-gray-600 text-center">
                David helps our clients navigate the legal aspects of property ownership in Costa Rica, ensuring all transactions are secure and compliant with local regulations.
              </p>
            </div>
          </div>
          
          <h2 className="text-3xl font-bold text-gray-800 mb-6">Why Choose Us?</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
            <div className="flex items-start">
              <svg className="w-12 h-12 text-primary mr-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
              </svg>
              <div>
                <h3 className="text-xl font-semibold text-gray-800 mb-2">Local Expertise</h3>
                <p className="text-gray-600">
                  Our team has deep knowledge of Costa Rica's regions, legal system, and property market. We'll help you navigate the local landscape with confidence.
                </p>
              </div>
            </div>
            
            <div className="flex items-start">
              <svg className="w-12 h-12 text-primary mr-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
              <div>
                <h3 className="text-xl font-semibold text-gray-800 mb-2">Personalized Service</h3>
                <p className="text-gray-600">
                  We take the time to understand your specific needs and preferences so we can match you with properties that truly meet your requirements.
                </p>
              </div>
            </div>
            
            <div className="flex items-start">
              <svg className="w-12 h-12 text-primary mr-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
              </svg>
              <div>
                <h3 className="text-xl font-semibold text-gray-800 mb-2">Transparent Transactions</h3>
                <p className="text-gray-600">
                  We believe in complete transparency throughout the buying process. No hidden fees or surprises—just honest, straightforward service.
                </p>
              </div>
            </div>
            
            <div className="flex items-start">
              <svg className="w-12 h-12 text-primary mr-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              <div>
                <h3 className="text-xl font-semibold text-gray-800 mb-2">Full-Service Support</h3>
                <p className="text-gray-600">
                  From property tours to legal paperwork, we provide end-to-end support to make your property purchase as smooth as possible.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Footer */}
      <footer className="bg-gray-800 text-gray-300">
        <div className="container-custom mx-auto px-4 py-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <h3 className="text-xl font-bold text-white mb-4">Costa Rica Properties</h3>
              <p className="mb-4">
                Your trusted partner for finding the perfect property in Costa Rica. With years of experience and local knowledge,
                we help you navigate the Costa Rican real estate market with confidence.
              </p>
              <div className="flex space-x-4">
                <a href="#" className="text-gray-300 hover:text-white">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M22.675 0h-21.35c-.732 0-1.325.593-1.325 1.325v21.351c0 .731.593 1.324 1.325 1.324h11.495v-9.294h-3.128v-3.622h3.128v-2.671c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.313h3.587l-.467 3.622h-3.12v9.293h6.116c.73 0 1.323-.593 1.323-1.325v-21.35c0-.732-.593-1.325-1.325-1.325z" />
                  </svg>
                </a>
                <a href="#" className="text-gray-300 hover:text-white">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723 10.049 10.049 0 01-3.128 1.196 4.92 4.92 0 00-8.393 4.48A13.919 13.919 0 011.64 3.161a4.92 4.92 0 001.525 6.573 4.858 4.858 0 01-2.232-.617v.061a4.932 4.932 0 003.947 4.838 5.026 5.026 0 01-2.223.085 4.947 4.947 0 004.6 3.437 9.885 9.885 0 01-6.115 2.111 10.08 10.08 0 01-1.174-.07 13.941 13.941 0 007.548 2.209c9.054 0 14.004-7.5 14.004-14.001 0-.21 0-.42-.015-.63a10.063 10.063 0 002.466-2.554l.047-.062z" />
                  </svg>
                </a>
                <a href="#" className="text-gray-300 hover:text-white">
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                  </svg>
                </a>
              </div>
            </div>
            <div>
              <h3 className="text-xl font-bold text-white mb-4">Quick Links</h3>
              <ul className="space-y-2">
                <li><a href="/" className="hover:text-primary transition-colors">Home</a></li>
                <li><a href="/properties" className="hover:text-primary transition-colors">Properties</a></li>
                <li><a href="/about" className="hover:text-primary transition-colors">About Us</a></li>
                <li><a href="/contact" className="hover:text-primary transition-colors">Contact</a></li>
              </ul>
            </div>
            <div>
              <h3 className="text-xl font-bold text-white mb-4">Popular Areas</h3>
              <ul className="space-y-2">
                <li><a href="#" className="hover:text-primary transition-colors">San Ramón</a></li>
                <li><a href="#" className="hover:text-primary transition-colors">Alajuela</a></li>
                <li><a href="#" className="hover:text-primary transition-colors">San José</a></li>
                <li><a href="#" className="hover:text-primary transition-colors">Guanacaste</a></li>
                <li><a href="#" className="hover:text-primary transition-colors">Puntarenas</a></li>
              </ul>
            </div>
            <div>
              <h3 className="text-xl font-bold text-white mb-4">Contact Us</h3>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <svg className="w-5 h-5 mr-2 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  <span>50 Metros Oeste del mercado municipal, San Ramón, Alajuela, Costa Rica</span>
                </li>
                <li className="flex items-start">
                  <svg className="w-5 h-5 mr-2 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                  <span>+506 6068-3184</span>
                </li>
                <li className="flex items-start">
                  <svg className="w-5 h-5 mr-2 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  <span>lic.rogersalasg@gmail.com</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="mt-12 border-t border-gray-700 pt-8 text-center text-sm">
            <p>&copy; {new Date().getFullYear()} Costa Rica Properties. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default AboutPage;